import { Grid } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import { TabNotaFiscal } from './components/TabNotaFiscal'
import { ParametrosNotaFiscalIO } from './ParametrosNotaFiscal.IO'
import { InformacaoParceiro } from '../../components/InformacaoParceiro'
import FolderOpenIcon from '@material-ui/icons/FolderOpen'
import { TooltipComponent } from '../../components/Tooltip/Tooltip'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { ContainerSombra } from '../../components/ContainerSombra'

export type ParametrosNotaFiscalProps = {}

export default function ParametrosNotaFiscalView({ _io }: IOProps<ParametrosNotaFiscalIO, ParametrosNotaFiscalProps>) {
  const { ContainerCircle, ContainerCabecalho, Titulo } = _io.styles

  return (
    <>
      <InformacaoParceiro />

      <ContainerCabecalho>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item>
            <ContainerCircle>
              <FolderOpenIcon color="primary" fontSize="large" />
            </ContainerCircle>
          </Grid>
          <Grid item>
            <Titulo>Parâmetros - Nota Fiscal</Titulo>
          </Grid>
          <Grid item>
            <TooltipComponent
              texto="Os parâmetros a seguir definem como o sistema processará a nota fiscal desse parceiro."
              Icone={HelpOutlineIcon}
              color={'action'}
            />
          </Grid>
        </Grid>
      </ContainerCabecalho>

      <ContainerSombra>
        <TabNotaFiscal />
      </ContainerSombra>
    </>
  )
}
